import { connect } from 'react-redux';
import ServiceType from './ServiceType';
import {
  verifyEmail,
  createLead,
  updateLead,
  getLeadById,
  getCommercialProposal,
  addCommercialProposal,
  addCommercialQuote,
  updateCommercialQuote,
  updateCommercialProposal,
  updateInnerCommercialProposal,
  addInnerCommercialProposal,
  getHistoricalData,
  getCustomerLastCompletedStepUUID,
  updateCustomerLastCompletedStep,
  registerCustomerLastCompletedStep,
  getQuoteById
} from "../../Actions"

const mapStateToProps = (state) => {
  const { 
    quote,
    loading,
    error,
    proposal,
    addInnerProposal,
    registered_proposal,
    quote_info
  } = state.commercialQuote;

  return {
    quote,
    error,
    loading,
    proposal,
    addInnerProposal,
    registered_proposal,
    email: state.email,
    inProgress: state.orderSubmit.inProgress,
    ResRegister: state.ResRegister,
    CustomerStep: state.CustomerStep,
    quote_info
  }
}

const actionCreators = {
  createLead,
  updateLead,
  verifyEmail,
  getHistoricalData,
  getLeadById,
  getCommercialProposal,
  updateCommercialQuote,
  updateCommercialProposal,
  updateInnerCommercialProposal,
  addCommercialQuote,
  addCommercialProposal,
  addInnerCommercialProposal,
  getCustomerLastCompletedStepUUID,
  updateCustomerLastCompletedStep,
  registerCustomerLastCompletedStep,
  getQuoteById
};

export default (connect(mapStateToProps, actionCreators)(ServiceType));